import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import '../../forms/superAdminForms/style.scss';
import AdminPageLayout from '../../layout/AdminPageLayout';
import Headline from '../../ui/Headline';
import ButtonsGroup from '../../ui/ButtonsGroup';
import Button from '../../ui/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTES } from '../../app.config.vars/routes';
import PlusIcon from '../../assets/icons/plus.svg';
import { useTranslation } from 'react-i18next';
import { generateIdRoutePath } from '../../helpers';
const SuperAdminUnitsPageLayout = ({ title, unit, children, institutionId, actions, }) => {
    const { id } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (_jsx(AdminPageLayout, { logoutButton: true, logoLink: unit === 'institution'
            ? APP_ROUTES.institutions
            : institutionId
                ? APP_ROUTES.institutions
                : APP_ROUTES.editors, children: _jsxs("div", { className: 'page-content-wrapper super-admin-units-page', children: [institutionId && (_jsx("div", { className: "back-button", children: _jsx(Button, { onClick: () => navigate(APP_ROUTES.institutions), label: t('button.return_to_institutions'), variant: 'outlined' }) })), _jsx(Headline, { title: title, type: 'h1' }), _jsxs(ButtonsGroup, { children: [_jsx(Button, { onClick: () => navigate(unit === 'institution'
                                ? APP_ROUTES.createInstitution
                                : id
                                    ? generateIdRoutePath(APP_ROUTES.superAdminCreateEditor, id)
                                    : APP_ROUTES.createEditor), label: unit === 'institution' ? t('button.add_institution') : t('button.add_editor'), icon: _jsx(PlusIcon, {}), iconSize: 'small' }), actions] }), children] }) }));
};
export default SuperAdminUnitsPageLayout;
